export default __webpack_public_path__ + "static/media/AppCrash2.a9daf99e.png";